import { useEffect, useState, useRef } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import "./assets/css/style.css";
import DureWebsite from "./Pages/DureWebsite";
import Product from "./Pages/Product";
import ScrollToTop from "./Components/ScrollToTop";
import Loader from "./Components/LoaderComponent/Loader";
import OpenLmis from "./Pages/OpenLmis";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time or wait for window.onload
    const handleLoad = () => {
      setTimeout(() => setLoading(false), 800); // small delay for smooth fade
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  return (
    <div className="App">
      {loading && <Loader />}

      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<DureWebsite />} />
        <Route path="/product" element={<Product />} />
        <Route path="/openlmis" element={<OpenLmis />}/>
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
